import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import ApiUiController from '../../../controller/ApiUiController';
import FieldController from '../../../controller/FieldController';
import LeadScoreAPI from '../../../api/LeadScoreAPI';
import LeadScoreConditionView from './leadScoreConditionView';
import Util from '../../../util/Util';
class LeadScorePreview extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.state = { inApiCall: true };
    const model = reactLocalStorage.getObject(Const.Model);
    this.model = model.lead;

    this.fields = FieldController.getFilterFields(this.model.fields);
    this.users = model.user.options;

    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.indexOf('/preview'));
    this.dist = { name: '', description: 0, condition: [] };
  }

  componentDidMount() {
    LeadScoreAPI.get(this.id, this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = dist => {
    const conditions = JSON.parse(dist.filters);
    this.dist = { name: dist.rule_name, description: dist.rule_description, condition: conditions };
    this.setState({ inApiCall: false });
  };

  render() {
    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className="row mb-6 d-block">
              <div className="col-md-6 pb-3"> <h4 >Rule Name: {this.dist.name}</h4></div>

              <div className="col-md-6 pb-3">  <h5>Rule Description: {this.dist.description}</h5></div>
              <div className="col-md-12">
              </div>

              <div className="formhead col-md-12"><h4>Rule Conditions</h4></div>
              <LeadScoreConditionView model={this.model} fields={this.fields} value={this.dist.condition} />
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(LeadScorePreview);
